import React from 'react';
import StatCard from '@/components/ui/StatCard';
import { Briefcase, Activity, CheckCircle2, TrendingUp, Wallet, IndianRupee } from 'lucide-react';

export const ProjectStats = ({ showDetails, stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full min-w-0">
      <StatCard 
        title="Total Projects" 
        value={stats.totalProjects} 
        icon={<Briefcase />} 
        color="bg-amber-500"
        variant="dashboard"
      />
      <StatCard 
        title="Completed" 
        value={stats.completedProjects} 
        icon={<CheckCircle2 />} 
        color="bg-emerald-500" 
        variant="dashboard"
      />
      <StatCard 
        title="Total PO Value" 
        value={stats.totalRevenue} 
        icon={<IndianRupee />} 
        color="bg-[#2B448F]" 
        variant="dashboard"
      />
      <StatCard 
        title="Total Balance Due" 
        value={stats.totalBalance} 
        icon={<Wallet />} 
        color="bg-indigo-600" 
        variant="dashboard"
      />
    </div>
  );
};
